import React from 'react';
import { useTranslation } from 'react-i18next';
import { EmailChangeConfirmationBase } from './EmailChangeConfirmationBase';
import { InvalidLinkContent } from './InvalidLinkContent';

export const NewEmailConfirmation: React.FC = () => {
  const { t } = useTranslation();

  return (
    <EmailChangeConfirmationBase
      texts={{
        confirmHeader: t('new_email_confirmation.confirm.header'),
        confirmBody: t('new_email_confirmation.confirm.body'),
      }}
      invalidContent={<InvalidLinkContent />}
    />
  );
}
